// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"136":"812a42c7","765":"730c026c","967":"4b012772"}[chunkId] + ".js";
};